import React from 'react';
import PropTypes from 'prop-types';
import {
  Page,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  IconSpinner,
  NamedRedirect,
  AdminNav,
} from '../../components';
import { TopbarContainer } from '../../containers';

import { isScrollingDisabled } from '../../ducks/UI.duck';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { isAdminAccount } from '../../util/userHelper';

import css from './AdminManageCommissionPage.css';

export const AdminManageCommissionPage = () => {
  const scrollingDisabled = useSelector(state => isScrollingDisabled(state));
  const isAuthenticated = useSelector(state => state.Auth.isAuthenticated);
  const currentUser = useSelector(state => state.user.currentUser);
  const isAdmin = isAdminAccount(currentUser);
  const intl = useIntl();

  const title = intl.formatMessage({ id: 'AdminPage.title' });

  if ((!isAdmin && currentUser && currentUser.id) || !isAuthenticated) {
    return <NamedRedirect name="NotFoundPage" />;
  }

  if (!isAdmin) {
    return (
      <Page title={title} scrollingDisabled={scrollingDisabled}>
        <LayoutSingleColumn>
          <LayoutWrapperTopbar>
            <TopbarContainer currentPage="AdminManageCommissionPage" />
          </LayoutWrapperTopbar>
          <LayoutWrapperMain>
            <div className={css.loadingWrapper}>
              <IconSpinner />
            </div>
          </LayoutWrapperMain>
          <LayoutWrapperFooter>
            <Footer />
          </LayoutWrapperFooter>
        </LayoutSingleColumn>
      </Page>
    );
  }

  return (
    <Page title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="AdminManageCommissionPage" />
          <AdminNav selectedPageName="AdminManageCommissionPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.container}>
            Comming soon (Now you can only use "Admin manage transactions page")
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

export default AdminManageCommissionPage;
